<template>
    <div class="banner">
        <v-container
          class="container-wrapper"  >
            <img src="@/assets/images/banner-icon.svg" class="banner-icon" alt="">                  
            <v-row
                align="center"
                justify="center"
                class="white--text py-12"
                no-gutters
            >
                <v-col cols="12" md="5" lg="4">
                    <div class="titles">
                    <h1 class="title mt-4 text-left" v-text="title"></h1>                        
                    </div>
                </v-col>
                 <v-col cols="12" md="5" lg="4">
                    <p class="description mt-4 text-left" v-text="description"></p>
                </v-col>
            </v-row>

            <v-btn rounded text color="white" class="mb-4 mb-lg-n8" v-if="backUrl" @click="goBack">
                <v-icon left>mdi-arrow-left</v-icon> {{ $t('Back') }}
            </v-btn>
        </v-container>
    </div>
</template>

<script>
    export default {
        name: 'pageBanerStudentForm',
        props: {
            title: String,
            title1: String,
            description: String,
            backUrl: String
        },
        methods: {
            goBack() {
                if(this.backUrl !== -1) {
                    this.$router.push(this.backUrl)
                } else {
                    this.$router.go(-1)
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
.banner{
    width: 100%;
    height: auto;
    padding-top: 40px;
    padding-bottom: 40px;
    position: relative;
    background: rgb(86,125,251);
    background: -moz-linear-gradient(top, rgba(86,125,251,1) 0%, rgba(56,217,253,1) 100%);
    background: -webkit-linear-gradient(top, rgba(86,125,251,1) 0%,rgba(56,217,253,1) 100%);
    background: linear-gradient(to bottom, rgba(86,125,251,1) 0%,rgba(56,217,253,1) 100%);
    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#567dfb', endColorstr='#38d9fd',GradientType=0 );
    overflow: hidden;

    .banner-icon{
        position: absolute;
        bottom: 0%;
        right: -2%;
    }
    .container-wrapper{
        display: flex;
        height: 100%;
        .titles{
            max-width: 438px;
            height: auto;
        }
        .description{
            width: 100%;
            font-size: 1.125rem !important;
            font-weight: 400;
            line-height: 1.75rem;
            letter-spacing: normal !important;
            font-family: "Raleway", serif !important;
        }
        .title{
            font-size: 4.063rem !important;
            font-weight: 400;
            line-height: 5rem;
            letter-spacing: normal !important;
            font-family: "Raleway", serif !important;
        }
        .title2{

            font-size: 4.063rem !important;
            font-weight: 400;
            line-height: 5rem;
            letter-spacing: normal !important;
            font-family: "Raleway", serif !important;
        }
    }

}
@media (max-width: 599px) {
    .banner{
        .banner-icon{
            display: none;
        }
    }
}
</style>